import { MapCircle } from '../map/map-circle';
import { MapShape } from '../map/map-shape';

export class MapShapesSearchOptions {
    constructor(
        public readonly shapes: MapShape[] = [],
        public readonly circles: MapCircle[] = []
    ) { }
}